var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.5L3 6M9 16.5L9 6M21 7.189L21 15.31C21 16.174 20.067 16.716 19.317 16.287L12.209 12.226C12.0367 12.1276 11.8935 11.9854 11.7939 11.8139C11.6942 11.6423 11.6418 11.4474 11.6418 11.249C11.6418 11.0506 11.6942 10.8557 11.7939 10.6841C11.8935 10.5126 12.0367 10.3704 12.209 10.272L19.317 6.211C19.4882 6.11322 19.682 6.06214 19.8792 6.06287C20.0763 6.0636 20.2698 6.11612 20.4402 6.21517C20.6107 6.31422 20.7521 6.45631 20.8504 6.62723C20.9486 6.79814 21.0002 6.99186 21 7.189Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackward);
export default __webpack_public_path__ + "static/media/arrowBackward.26ca333f4d7cd8ebb98e9977d195b37a.svg";
export { ForwardRef as ReactComponent };